import constants from '../lib/constants'

const showMilesNBonus = ({
  selectedVehicle,
  milesNBonusAccount,
  isPrepaid,
  filteredCars,
}) => {
  const isGreek = !!window.bookingData
    ? window.bookingData?.pickUpDetails?.countryCode?.toLowerCase() === 'gr'
    : window.modifyData?.values?.pickUpLocation?.country?.toLowerCase() === 'gr'

  const eligibleToRedeem =
    milesNBonusAccount?.eligibilityStatus ===
      constants.booking.milesNBonus.eligible ||
    milesNBonusAccount?.eligibilityStatus === undefined
  const enoughMiles =
    milesNBonusAccount?.remainingMiles >= milesNBonusAccount?.minimumMiles ||
    milesNBonusAccount?.remainingMiles === undefined
  const eligibleSelectedBrand =
    selectedVehicle?.brandName?.toLowerCase() ===
    constants.booking.milesNBonus.eligibleBrand.toLowerCase()

  const mainCondition = eligibleToRedeem && enoughMiles && isGreek

  // Check if filtered cars contain at least one Hertz brand (only on step 1)
  if (filteredCars !== null && filteredCars !== undefined) {
    const hasHertzBrand = filteredCars.some(
      (car) =>
        car.brandCode?.toLowerCase() ===
        constants.booking.milesNBonus.eligibleBrand.toLowerCase()
    )

    // Hide alert if NO Hertz cars are shown in filtered results
    if (!hasHertzBrand) {
      return false
    }
  }

  const vehicleCondition =
    !selectedVehicle || (eligibleSelectedBrand && isPrepaid)

  return mainCondition && vehicleCondition
}

export default showMilesNBonus
